import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface IReturnState {
  returnTo?: string;
}

// Guided Search opened from another page (the global search) carries that page along, so Cancel
// can take the user back to it.
export const usePartFinderReturn = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const returnTo = (state as IReturnState | null)?.returnTo;

  const navigateWithReturn = useCallback(
    (path: string) => navigate(path, { state: returnTo ? { returnTo } : undefined }),
    [navigate, returnTo]
  );

  const cancel = useCallback(() => returnTo && navigate(returnTo), [navigate, returnTo]);

  return { returnTo, navigateWithReturn, cancel };
};
